import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "创建人部门" }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: "部门单选" }),
    },
};
